<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="3000"
          :reset="true"
          :custom-sim-query-placeholder="this.$t('Clearing.QuickRetrieval') + this.$t('CargoMsg.Cargo_MasterAirwayBill')"
          :custom-search-items="customSearchItems"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="deliverySecurityCheckHandler"
            >{{ this.$t('CargoMsg.Cargo_DeliverySecurityCheck') }}
            </el-button>
            <el-button
              type="primary"
              @click="outboundWeightHandler"
            >{{ this.$t('CargoMsg.Cargo_OutboundWeight') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="24000522"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="24000521"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>

    <delivery-operation
      v-if="deliveryOperationWindow.visible"
      :visible.sync="deliveryOperationWindow.visible"
      :title="deliveryOperationWindow.title"
      :page-type="deliveryOperationWindow.type"
      @close="deliveryOperationWindow.visible = false"
    />
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  advancedQuery
} from '@/api/AirExport/airExportJob'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DeliveryOperation from '@/views/cargo/v0/AirExport/components/cargoTerminalDelivery/deliveryOperation.vue'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'CargoTerminalDelivery',
  components: {
    DeliveryOperation,
    searchItem
  },
  data() {
    return {
      URL,
      customSearchItems: [],
      isAdvancedQuery: false, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      deliveryOperationWindow: {
        visible: false,
        title: '',
        type: 0
      },
      templateName: null,
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MasterAirwayBill'),
          colId: 'mbl',
          field: 'mbl',
          width: 150,
          valueFormatter: (params) => {
            if (params.value && params.value.length > 3) {
              return params.value.slice(0, 3) + '-' + params.value.slice(3)
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryCargoStation'),
          colId: 'cargoTerminalOperation',
          field: 'cargoTerminalOperation',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirportCargoTerminal, 'uuid', params.value, 'warehouseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerName'),
          colId: 'customerId',
          field: 'customerId',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SplitOrderNumber'),
          colId: 'lclNum',
          field: 'lclNum',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TotalPieces'),
          colId: 'quantityStation',
          field: 'quantityStation',
          width: 150,
          valueFormatter: (params) => {
            if (params.data.outboundWeightDate) {
              return params.value
            } else {
              if (params.data.quantityActual) {
                return params.data.quantityActual
              } else if (params.data.quantityBooking) {
                return params.data.quantityBooking
              } else if (params.data.quantityContract) {
                return params.data.quantityContract
              }
            }
            return 0
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TotalGrossWeight'),
          colId: 'weightStation',
          field: 'weightStation',
          width: 150,
          valueFormatter: (params) => {
            if (params.data.outboundWeightDate) {
              return params.value
            } else {
              if (params.data.weightActual) {
                return params.data.weightActual
              } else if (params.data.weightBooking) {
                return params.data.weightBooking
              } else if (params.data.weightContract) {
                return params.data.weightContract
              }
            }
            return 0
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TotalChargeableWeight'),
          colId: 'chargeWeightStation',
          field: 'chargeWeightStation',
          width: 150,
          valueFormatter: (params) => {
            if (params.data.outboundWeightDate) {
              return params.value
            } else {
              if (params.data.chargeWeightActual) {
                return params.data.chargeWeightActual
              } else if (params.data.chargeWeightBooking) {
                return params.data.chargeWeightBooking
              } else if (params.data.chargeWeightContract) {
                return params.data.chargeWeightContract
              }
            }
            return 0
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TotalVolume'),
          colId: 'cubageStation',
          field: 'cubageStation',
          width: 150,
          valueFormatter: (params) => {
            if (params.data.outboundWeightDate) {
              return params.value
            } else {
              if (params.data.cubageActual) {
                return params.data.cubageActual
              } else if (params.data.cubageBooking) {
                return params.data.cubageBooking
              } else if (params.data.cubageContract) {
                return params.data.cubageContract
              }
            }
            return 0
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryOperator'),
          colId: 'deliveryUser',
          field: 'deliveryUser',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryOperationTime'),
          colId: 'deliveryDate',
          field: 'deliveryDate',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryOperationMethod'),
          colId: 'deliverySource',
          field: 'deliverySource',
          width: 150,
          valueFormatter: (params) => {
            return String(params.value) === '1' ? 'PDA' : 'PC'
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WeightOutOperator'),
          colId: 'outboundWeightUser',
          field: 'outboundWeightUser',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WeightOutOperationTime'),
          colId: 'outboundWeightDate',
          field: 'outboundWeightDate',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WeightOutOperationMethod'),
          colId: 'outboundWeightSource',
          field: 'outboundWeightSource',
          width: 150,
          valueFormatter: (params) => {
            return String(params.value) === '1' ? 'PDA' : 'PC'
          }
        }
      ],
      rowData: []
    }
  },
  computed: {},
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  created() {
    this.initConfig()
  },
  beforeMount() {
    setTimeout(() => {
      this.toQuery()
    }, 0)
  },
  methods: {
    // 初始化一些 config表的配置信息
    async initConfig() {
      this.customSearchItems = await this.getCustomSearchItems()
    },
    async getCustomSearchItems() {
      const defaultSearchFields = []
      const operations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
      const warehouseOperations = operations.filter(data => data.dataType === 0)
        .map(item => ({
          code: item.uuid,
          chineseName: item.warehouseName,
          englishName: item.warehouseName
        }))
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'airExportJob.CARGO_TERMINAL_OPERATION'
      searchField.itemLabel = 'CargoMsg.Cargo_DeliveryCargoStation'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'warehouseName'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = warehouseOperations
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      const options = []
      if (typeof keyword !== 'undefined') {
        options.push(new AdvancedSearchOption('FIELD_MULTI_TEXT', 'job.MBL', keyword, AdvancedSearchConsts.OPERATOR_EQUAL.code))
        this.filter.conditions = []
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      this.filter.conditions = this.addConditionsBeforeQuery(options)
      this.filter.requires = ['cargoTerminalDelivery']
      advancedQuery(this.filter).then((res) => this.handleQueryData(res)).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = this.addConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.requires = ['cargoTerminalDelivery']
      this.fullscreenLoading = getLoading4Cxt()
      advancedQuery(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', data)) {
        const jobStates = [SystemConstants.STATE_VERIFYING.code, SystemConstants.STATE_REJECT.code]
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, AdvancedSearchConsts.OPERATOR_NOT_IN.code)
        data.push(option.formatObj2Json())
      }

      const option2 = new AdvancedSearchOption(null, 'airExportJob._cargoTerminalOperationStr_', null, OperatorConstants.OPERATOR_IS_NOT_NULL.code)
      data.push(option2.formatObj2Json())
      // 不显示关联业务
      const option3 = new AdvancedSearchOption(null, 'loadRelationJobs', false, OperatorConstants.OPERATOR_EQUAL.code)
      data.push(option3.formatObj2Json())
      return data
    },
    // 交货（安检机）
    deliverySecurityCheckHandler() {
      this.deliveryOperationWindow.type = 1
      this.deliveryOperationWindow.title = this.$t('CargoMsg.Cargo_DeliveryOperation')
      this.deliveryOperationWindow.visible = true
    },
    // 出重
    outboundWeightHandler() {
      this.deliveryOperationWindow.type = 0
      this.deliveryOperationWindow.title = this.$t('CargoMsg.Cargo_OutboundWeight2')
      this.deliveryOperationWindow.visible = true
    }
  }
}
</script>
